<template>
    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-6">
        <div class="lg:tw-col-span-8">
            <section :class="props.theme === 'dark' ? 'tw-bg-[#1A1D21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-p-6 tw-shadow-2xl">
                <div class="tw-flex tw-items-center tw-justify-between tw-mb-6">
                    <h2 :class="props.theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold tw-text-xl">Termometria</h2>
                    <button
                        type="button"
                        @click="disparaLeitura(silo.id)"
                        :disabled="loading || bloqueioLeituraDisparada"
                        :class="[
                            'tw-px-3 tw-py-2 tw-rounded-xl tw-font-semibold tw-text-sm tw-text-white',
                            textoBotao === 'Leitura disparada!'
                                ? 'tw-bg-slate-600 hover:tw-bg-slate-700'
                                : 'tw-bg-emerald-600 hover:tw-bg-emerald-700',
                            (loading || bloqueioLeituraDisparada) && 'tw-opacity-50 tw-cursor-not-allowed'
                        ]"
                    >
                        {{ textoBotao }}
                    </button>
                </div>

                <div class="tw-mb-6">
                    <div class="tw-flex tw-gap-8">
                        <button
                            @click="activateTabTermometria(true)"
                            :class="[
                                'tw-pb-4 tw-font-semibold tw-text-sm',
                                tabTermometria
                                    ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                    : (props.theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                            ]"
                        >
                            Termometria
                        </button>
                        <button
                            @click="activateTabTermometria(false)"
                            :class="[
                                'tw-pb-4 tw-font-semibold tw-text-sm',
                                !tabTermometria
                                    ? 'tw-text-emerald-600 tw-border-b-2 tw-border-emerald-600'
                                    : (props.theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-slate-300' : 'tw-text-slate-500 hover:tw-text-slate-600')
                            ]"
                        >
                            Silo 3D
                        </button>
                    </div>
                </div>

                <div class="tw-mt-6">
                    <div v-if="tabTermometria">
                        <SelectLeituras :leituras="leituras" @changeLeitura="leituraChangeSelect" :theme="props.theme"/>
                        <ViewLeitura :termometria="termometria" :theme="props.theme"/>
                    </div>
                    <div v-else>
                        <Silo3dComponent :silo="silo" :termometria="termometria" :theme="props.theme"/>
                    </div>
                </div>
            </section>
            <div v-if="silo.existe_aeracao" class="tw-col-span-12 tw-gap-6 tw-mt-6">
                <AeracaoContent :aeracao="silo.aeracao" :programa="silo.programa" :modoOperacao="silo.modo_operacao" :theme="props.theme"/>
            </div>
        </div>
        <div class="lg:tw-col-span-4">
            <InformacoesGeraisBySilo :silo="silo" :theme="props.theme" />
        </div>
    </div>
</template>
<script>
import SelectLeituras from './Termometria/SelectLeituras.vue';
import ViewLeitura from './Termometria/ViewLeitura.vue';
import InformacoesGeraisBySilo from './Termometria/InformacoesGeraisBySilo.vue';
import AeracaoContent from './Termometria/AeracaoContent.vue';
import Silo3dComponent from './Termometria/Silo3dComponent.vue';

import { ref, watch } from "vue";
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';

export default {
    props: {
        silo: Object,
        leituras: Array,
        termometria: Object,
        theme: String
    },
    components: {
        SelectLeituras,
        ViewLeitura,
        InformacoesGeraisBySilo,
        AeracaoContent,
        Silo3dComponent
    },
    setup(props) {
        const tabTermometria = ref(true);
        const loading = ref(false);
        const textoBotao = ref('Iniciar nova Leitura');
        const bloqueioLeituraDisparada = ref(false);
        const store = useStore();
        const toast = useToast();

        const disparaLeitura = async ($siloId) => {
            try{
                loading.value = true;
                textoBotao.value = 'Disparando...';
                const response = await store.dispatch('silo/disparaLeitura', $siloId);
                toast.info("Disparo enviado ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                let messageId = response.data.message.message_id;
                setTimeout(async () => {
                    let msg = await store.dispatch("message/fetchMessage", messageId);
                    if (msg.status !== 'processed') {
                        toast.error("Disparo de leitura não processado pelo Painel TermoWeb.");
                        loading.value = false;
                        textoBotao.value = 'Iniciar nova Leitura';
                        bloqueioLeituraDisparada.value = false;
                        loading.value = false;
                    } else {
                        toast.success("Disparo enviado ao silo.");
                        loading.value = false;
                        textoBotao.value = 'Leitura disparada!';
                        bloqueioLeituraDisparada.value = true;
                        loading.value = false;
                    }
                }, 4000);
            } catch (error) {
                loading.value = false;
                textoBotao.value = 'Iniciar nova Leitura';
                bloqueioLeituraDisparada.value = false;
                toast.error('Erro ao disparar leitura');
            }
        }

        watch(() => props.silo, () => {
            loading.value = false;
            textoBotao.value = 'Iniciar nova Leitura';
            bloqueioLeituraDisparada.value = false;
        });

        return {
            tabTermometria,
            activateTabTermometria: (action) => tabTermometria.value = action,
            disparaLeitura,
            loading,
            textoBotao,
            bloqueioLeituraDisparada,
            props
        }
    },
    methods: {
        leituraChangeSelect(value) {
            this.$emit('selectedLeitura', value);
        }
    }
}
</script>